export default class Department {
  static getRegionsList() {
    if (window?.API) {
      return window.API.departments
      || window.API['screening-search-page']?.departments
      || window.API['screening-results-page']?.departments
      || window.API['vaccination-search-page']?.departments
      || window.API['vaccination-results-page']?.departments;
    }
    return {
      '01 - Ain': 'https://www.sante.fr/cf/centres-depistage-covid/departement-10-aube.html',
      'dep-02-aisn': '02 - Aisne',
      'dep-03-allie': '03 - Allier',
      'dep-04-alpes-de-haute-provence': '04 - Alpes-de-Haute-Provence',
      'dep-05-hautes-alpes': '05 - Hautes-Alpe',
      'dep-06-alpes-maritimes': '06 - Alpes-Maritimes',
    };
  }

  static getCurrentDepartment() {
    if (window?.API) {
      return window.API.current
      || window.API['screening-search-page']?.current
      || window.API['screening-results-page']?.current
      || window.API['vaccination-search-page']?.current
      || window.API['vaccination-results-page']?.current;
    }
    return '';
  }

  static getCitiesList() {
    if (window?.API) {
      return window.API.cities
      || window.API['vaccination-results-page']?.cities || window.API['screening-results-page']?.cities;
    }

    return undefined;
  }

  static getPlacesList() {
    if (window?.API) {
      return window.API.places
        || window.API['vaccination-results-page']?.places || window.API['screening-results-page']?.places;
    }
    return undefined;
  }
}
